export default __webpack_public_path__ + "img/250MA_BF.b6ec5280ddf04ece7b4c1b085d65b0e7.jpg";